import { HomePulse } from "./HomePulse";
import { HomeToday } from "./HomeToday";
import { useHomeView } from "./homeView";

/**
 * Desktop home: view A «Hoy» or B «Pulso», picked with the header toggle.
 * The incoming view is keyed so it remounts with a quick fade + lift
 * (.home-view in styles/home.css, plain instant swap with reduced motion).
 */
export const DesktopHome = () => {
  const [view] = useHomeView();
  return (
    <div key={view} className="home-view" data-view={view}>
      {view === "pulse" ? <HomePulse /> : <HomeToday />}
    </div>
  );
};
